import { render, staticRenderFns } from "./FeedsCard.vue?vue&type=template&id=565cd438&scoped=true&"
import script from "./FeedsCard.vue?vue&type=script&lang=js&"
export * from "./FeedsCard.vue?vue&type=script&lang=js&"
import style0 from "./FeedsCard.vue?vue&type=style&index=0&id=565cd438&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565cd438",
  null
  
)

export default component.exports